<div class="right-side p-5">
  <h2>Update Events Date</h2>
  <div class="section">
    <div class="table-responsive">
      <!-- 🔍 Search -->

      <div class="text-end">
        <button class="btn btn-sm btn-success me-2" (click)="onchangeDate()">
          <i class="bi bi-pencil-square"></i>
          Change Event Date
        </button>
      </div>



      <div class="col-lg-7 col-sm-12">
        <!-- Search -->
        <mat-form-field appearance="outline" class="search-input w-75">
          <mat-label>Search...</mat-label>
          <input matInput
                 [(ngModel)]="pagination.searchTerm"
                 (keyup.enter)="loadData()" />
        </mat-form-field>

        <!-- Search Button -->
        <button class="btn btn-outline-secondary p-2 mx-1 search-button"
                (click)="loadData()">
          <i class="bi bi-search fs-4"></i>
        </button>

        <!-- Reset Button -->
        <button class="btn btn-outline-secondary p-2" (click)="resetFilters()">
          <i class="bi bi-arrow-clockwise fs-4"></i>
        </button>
      </div>
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Sr.No</th>
            <th>Event Id </th>

            <th (click)="sort('EventName')">Event Name ⬍</th>




            <th (click)="sort('PreviousEventDate')">Old Date ⬍</th>

            <th (click)="sort('UpdatedEventDate')">Updated Date ⬍</th>

            <th>Old Time</th>

            <th>Updated Time</th>

            <th>Remark</th>
            <th>Attachment</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of dataSource; let i = index">
            <td>
              {{ (pagination.pageNumber - 1) * pagination.pageSize + i + 1 }}
            </td>

            <td>{{ row.EventCode }}</td>

            <td>{{ row.EventName }}</td>



            <td>{{ row.PreviousEventDate | date: "dd/MM/yyyy" }}</td>

            <td>{{ row.UpdatedEventDate | date: "dd/MM/yyyy" }}</td>

            <td>{{ row.PreviousTime }}</td>

            <td>{{ row.UpdatedTime }}</td>
            <td>{{ row.Remark }}</td>
            <td>
              <button *ngIf="row.FilePath"
                      class="btn btn-sm btn-primary"
                      (click)="downloadFile(row)"
                      title="Download">
                <i class="bi bi-download"></i>
              </button>
            </td>
          </tr>

          <!-- ❌ No Data -->
          <tr *ngIf="dataSource.length === 0">
            <td colspan="6" class="text-center">No data available</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 📄 Pagination -->
    <mat-paginator [length]="totalRecords"
                   [pageSize]="pagination.pageSize"
                   [pageIndex]="pagination.pageNumber - 1"
                   [pageSizeOptions]="[5, 10, 20, 50]"
                   (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</div>
